/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Mgr_Edit_TitleInputs */



/**
* | output |
* | --- |
* | "Edit Sanction" |
*
* @param {Sanction_Mgr_Edit_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_mgr_edit_title = /** @type {((inputs?: Sanction_Mgr_Edit_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Mgr_Edit_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modifier la sanction")
	if (locale === "es") return /** @type {LocalizedString} */ ("Editar sanción")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Editar Sanção")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modifica Sanzione")
	return /** @type {LocalizedString} */ ("Edit Sanction")
});